import {
    ChangeDetectionStrategy,
    Component,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { AppStateFacade } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import {
    FeatureFlag,
    IJob,
    JobState,
} from '@models';
import { isJson } from '@utils/string.utils';

import cloneDeep from 'lodash-es/cloneDeep';

@Component({
    templateUrl: 'job-details.modal.html',
    styleUrls: ['job-details.modal.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobDetailsModalComponent
    extends UiModalComponent<IJob>
    implements OnInit {

    private _appState = this._injector.get<AppStateFacade>(AppStateFacade);

    public get isJobSuspended() {
        return this._appState.settings.isFeatureEnabled(FeatureFlag.LongRunningJobs) &&
            this.context.data.state === JobState[JobState.Suspended];
    }

    ngOnInit() {
        this.context.data = cloneDeep(this.context.data);
        this.context.data.inputArguments = this._deserialize(this.context.data.inputArguments);
        this.context.data.outputArguments = this._deserialize(this.context.data.outputArguments);
    }

    private _deserialize = (args: string | Record<string, any>) => {
        if (
            args == null ||
            args === 'null' ||
            !isJson(args as string)
        ) { return args as Record<string, any>; }

        const parsed = JSON.parse(args as string) as Record<string, any>;

        Object.keys(args)
            .forEach(key => {
                const parameterValue = parsed[key];
                try {
                    parsed[key] = JSON.parse(parameterValue);
                } catch (e) {
                    parsed[key] = parameterValue;
                }
            });

        return parsed;
    }
}
